// /home/Hakyury/sites/oauth.eight-percent.com/frontend/src/hooks/useAuth.js

import { useState, useEffect, useCallback } from 'react';
import { getTokens, getUserInfo, isAuthenticated, checkSession, extractTokensFromURL } from '../utils/authFetch';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const updateAuthState = useCallback(() => {
    const tokens = getTokens();
    
    if (!tokens.access) {
      setUser(null);
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    const userInfo = getUserInfo();
    if (userInfo) {
      setUser(userInfo);
      setIsAdmin(userInfo.role === 'Администратор');
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    const initializeAuth = async () => {
      setLoading(true);
      
      // Извлекаем токены из URL если есть
      extractTokensFromURL();
      
      // Проверяем сессию при загрузке
      const isValid = await checkSession();
      if (!isValid) {
        setUser(null);
        setIsAdmin(false);
      } else {
        updateAuthState();
      }
      
      setLoading(false);
    };
    
    initializeAuth();
    
    // Слушаем изменения в localStorage (синхронизация между вкладками)
    const handleStorageChange = (e) => {
      if (e.key && e.key.includes('eight_percent_')) {
        updateAuthState();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Проверяем авторизацию каждые 5 минут
    const interval = setInterval(async () => {
      const isValid = await checkSession();
      if (!isValid) {
        setUser(null);
        setIsAdmin(false);
      }
    }, 5 * 60 * 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [updateAuthState]);

  return {
    user,
    loading,
    isAuthenticated: isAuthenticated(),
    isAdmin,
    updateAuthState
  };
}